(() => {
  const FOCUSABLE = 'button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function init(scope) {
    if (!scope || scope.dataset.aoSizeGuideReady === "true") return;
    const modal = scope.querySelector("[data-size-guide-modal]");
    const openButtons = [...scope.querySelectorAll("[data-size-guide-open]")];
    if (!modal || !openButtons.length) return;
    scope.dataset.aoSizeGuideReady = "true";
    const closeButtons = [...modal.querySelectorAll("[data-size-guide-close]")];
    let lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("ao-size-modal-open");
      (modal.querySelector(".ao-size-modal__close") || modal.querySelector(".ao-size-modal__dialog"))?.focus();
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("ao-size-modal-open");
      if (lastFocus instanceof HTMLElement) lastFocus.focus();
    }

    openButtons.forEach(button => button.addEventListener("click", open));
    closeButtons.forEach(button => button.addEventListener("click", close));
    modal.addEventListener("keydown", event => {
      if (event.key === "Escape") { event.preventDefault(); close(); return; }
      if (event.key !== "Tab") return;
      const focusable = [...modal.querySelectorAll(FOCUSABLE)].filter(element => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  function boot(root = document) {
    root.querySelectorAll("[data-ao-size-guide-scope]").forEach(init);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => boot());
  else boot();
  document.addEventListener("shopify:section:load", event => boot(event.target));
})();
